import React, { useEffect } from 'react';

export function useNetwork() {
  const [available, setAvailable] = React.useState(navigator.onLine);

  useEffect(() => {
    const onOffline = () => setAvailable(false);
    const onOnline = () => setAvailable(true);

    window.addEventListener('offline', onOffline);
    window.addEventListener('online', onOnline);

    return () => {
      window.removeEventListener('offline', onOffline);
      window.removeEventListener('online', onOnline);
    };
  }, []);

  return available;
}
